"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _mobileDetect = _interopRequireDefault(require("mobile-detect"));
var _rcPagination = _interopRequireDefault(require("rc-pagination"));
require("rc-pagination/assets/index.css");
var _fr_FR = _interopRequireDefault(require("rc-pagination/lib/locale/fr_FR"));
var _react = _interopRequireDefault(require("react"));
var _ConfirmationDialog = _interopRequireDefault(require("react-platform-components/dist/ConfirmationDialog"));
var _Translations = require("react-platform-components/dist/Translations");
var _reactRouterDom = require("react-router-dom");
var _config = require("../config");
var _index2 = require("../helpers/index");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var md = new _mobileDetect.default(window.navigator.userAgent);
var isMobile = md.mobile();

/**
 * This class is our resourse page container, it contains the page header,
 * resource list, creation dialog, delete confirmation dialog and pagination.
 *
 * Use it with injectToBaseContainer to provide these props:
 *  - componentDidMount: override the componentDidMount completely
 *  - beforeComponentDidMount: excuted before the dispatch of the FETCH_ACTION
 *  - afterComponentDidMount: excuted after the dispatch of the FETCH_ACTION
 *  - FETCH_ACTION: name of action to be dispatched when the component is mounted
 *  - DELETE_ACTION: name of action to be dispatched to delete a resource
 *  - creationType: dialog or page, dialog to use the form inside a dialog, page to use the form in a separate page
 *  - creationTypeEndpoint: needs to be passed when creationType is page, it is the path endpoint
 *  - listComponent: a component to show the list of the resources
 *  - createComponent: a component that contains a dialog with the form
 *  - headerIcon: header icon
 *  - headerTitle: header title
 *  - detailEndpoint: the endpoint of the link to view the resource detail
 *  - confirmTitle: title of confirmation dialog
 *  - confirmAction: confirmation action of confirmation dialog
 *      NOTE: this NEEDS to be a function expression and NOT an arrow function in order
 *      to bind this to it and use the component state and props.
 *
 * NOTE: all the props that are provided by HOCs (ex: redux connect) are injected with injectToBaseContainer
 */
var BaseContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseContainer, _React$Component);
  var _super = _createSuper(BaseContainer);
  function BaseContainer(props) {
    var _this;
    _classCallCheck(this, BaseContainer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "closeCreateProduct", function () {
      _this.setState({
        createProductOpen: false,
        isEdit: false,
        selectedProduct: {}
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openCreateProduct", function () {
      _this.setState({
        createProductOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openEdit", function (product) {
      return function () {
        _this.setState({
          createProductOpen: true,
          selectedProduct: product,
          isEdit: true
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "openConfirmDialog", function (product) {
      return function () {
        _this.setState({
          confirmDialogOpen: true,
          selectedProduct: product
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "closeConfirmDialog", function () {
      _this.setState({
        confirmDialogOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "deleteProduct", function () {
      _this.props.dispatch({
        type: _this.props.DELETE_ACTION,
        product: _this.state.selectedProduct,
        page: _this.props.pagination.page
      });
      _this.closeConfirmDialog();
    });
    _defineProperty(_assertThisInitialized(_this), "handlePagination", function (page) {
      var _this$props, _assertThisInitialize, _assertThisInitialize2;
      _this.props.FETCH_ACTION && _this.props.dispatch({
        type: _this.props.FETCH_ACTION,
        params: {
          _page: page,
          _per_page: _config.PRODUCTS_PER_PAGE,
          _fields: (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.fields,
          _embed: (_assertThisInitialize = _assertThisInitialized(_this)) === null || _assertThisInitialize === void 0 ? void 0 : (_assertThisInitialize2 = _assertThisInitialize.props) === null || _assertThisInitialize2 === void 0 ? void 0 : _assertThisInitialize2.embed
        }
      });
      (0, _index2.scrollToTop)();
    });
    /**
     * This function will handle which button type to display and it's behaviour
     * it can open a dialog or be a link to another page
     * in mobile it will show a FAB
     * in desktop it will show a button in the header
     */
    _defineProperty(_assertThisInitialized(_this), "handleCreationButton", function () {
      var _this$props2 = _this.props,
        creationTypeEndpoint = _this$props2.creationTypeEndpoint,
        creationType = _this$props2.creationType,
        user = _this$props2.user;
      var linkEndpoint = "/".concat(creationTypeEndpoint);
      var userRoles = user.roles;
      var hiddenRoles = _config.HIDE_CREATE_PRODUCT_BUTTON_BY_USER_ROLES;
      if (!userRoles.some(function (item) {
        return hiddenRoles.includes(item);
      })) {
        if (creationType === 'dialog') {
          return /*#__PURE__*/_react.default.createElement(_core.Button, {
            variant: "contained",
            color: "primary",
            onClick: _this.openCreateProduct
          }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Create product"
          }));
        }
        if (creationType === 'page' && creationTypeEndpoint) {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
            to: linkEndpoint,
            style: {
              textDecoration: 'none'
            }
          }, /*#__PURE__*/_react.default.createElement(_core.Button, {
            variant: "contained",
            color: "primary",
            onClick: _this.openCreateProduct
          }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Create product"
          })));
        }
      }
    });
    _this.state = {
      createProductOpen: false,
      isEdit: false,
      selectedProduct: {},
      confirmDialogOpen: false
    };
    return _this;
  }
  _createClass(BaseContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.componentDidMount) {
        this.props.componentDidMount(this.props);
      } else {
        var _this$props3, _this$props4;
        if (this.props.beforeComponentDidMount) {
          this.props.beforeComponentDidMount(this.props);
        }
        this.props.FETCH_ACTION && this.props.dispatch({
          type: this.props.FETCH_ACTION,
          params: {
            _page: 1,
            _per_page: _config.PRODUCTS_PER_PAGE,
            _fields: this === null || this === void 0 ? void 0 : (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.fields,
            _embed: this === null || this === void 0 ? void 0 : (_this$props4 = this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.embed
          }
        });
        if (this.props.afterComponentDidMount) {
          this.props.beforeComponentDidMount(this.props);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$theme$pal;
      var _this$props5 = this.props,
        products = _this$props5.products,
        pagination = _this$props5.pagination,
        headerIcon = _this$props5.headerIcon,
        headerTitle = _this$props5.headerTitle,
        detailEndpoint = _this$props5.detailEndpoint,
        confirmAction = _this$props5.confirmAction,
        confirmTitle = _this$props5.confirmTitle,
        _this$props5$hasHeade = _this$props5.hasHeader,
        hasHeader = _this$props5$hasHeade === void 0 ? true : _this$props5$hasHeade,
        _this$props5$hasPagin = _this$props5.hasPagination,
        hasPagination = _this$props5$hasPagin === void 0 ? true : _this$props5$hasPagin,
        _this$props5$extraPro = _this$props5.extraProps,
        extraProps = _this$props5$extraPro === void 0 ? {} : _this$props5$extraPro,
        _this$props5$inProgre = _this$props5.inProgress,
        inProgress = _this$props5$inProgre === void 0 ? false : _this$props5$inProgre;
      var _this$state = this.state,
        selectedProduct = _this$state.selectedProduct,
        isEdit = _this$state.isEdit,
        createProductOpen = _this$state.createProductOpen,
        confirmDialogOpen = _this$state.confirmDialogOpen;
      var classes = this.props.classes || {};
      var ListComponent = this.props.listComponent;
      var CreateComponent = this.props.createComponent;
      return /*#__PURE__*/_react.default.createElement("div", null, hasHeader && /*#__PURE__*/_react.default.createElement("div", {
        className: "p-12 pt-80 flex flex-1 flex-col items-center justify-center md:flex-row md:items-end ".concat(classes && classes.header),
        style: !classes || classes && !classes.header ? _objectSpread({
          backgroundColor: "#0a76a9",
          backgroundImage: "url(\"".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png\")"),
          backgroundSize: 'cover',
          color: '#fff',
          display: 'flex',
          minHeight: '10vh'
        }, (_this$props$theme$pal = this.props.theme.palette.custom) === null || _this$props$theme$pal === void 0 ? void 0 : _this$props$theme$pal.headerOfBaseContainer) : {}
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start white"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        className: "white",
        variant: "h5"
      }, headerTitle ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: headerTitle
      }) : /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Tilte"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "flex items-center justify-end ".concat(isMobile ? 'mt-4' : '')
      }, this.handleCreationButton())), !hasHeader && /*#__PURE__*/_react.default.createElement("div", {
        className: "grid place-items-center mt-6"
      }, this.handleCreationButton()), /*#__PURE__*/_react.default.createElement(ListComponent, {
        products: products,
        openConfirmDialog: this.openConfirmDialog,
        openEdit: this.openEdit,
        classes: classes,
        detailEndpoint: detailEndpoint,
        extraProps: extraProps,
        inProgress: inProgress
      }), createProductOpen && /*#__PURE__*/_react.default.createElement(CreateComponent, {
        open: createProductOpen,
        close: this.closeCreateProduct,
        isEdit: isEdit,
        selectedProduct: selectedProduct
      }), confirmDialogOpen && /*#__PURE__*/_react.default.createElement(_ConfirmationDialog.default, {
        closeLabel: "Annuler",
        confirmLabel: "Confirmer",
        title: confirmTitle ? confirmTitle : 'Êtes-vous sûr de vouloir supprimer ce produit?',
        open: confirmDialogOpen,
        close: this.closeConfirmDialog,
        confirmAction: confirmAction ? confirmAction.bind(this) : this.deleteProduct
      }), hasPagination && pagination && pagination.page && /*#__PURE__*/_react.default.createElement(_rcPagination.default, {
        className: "flex justify-center ".concat(classes.pagination),
        onChange: this.handlePagination,
        current: pagination.page,
        total: pagination.count,
        pageSize: _config.PRODUCTS_PER_PAGE,
        locale: _fr_FR.default
      }));
    }
  }]);
  return BaseContainer;
}(_react.default.Component);
var styles = function styles(theme) {
  return {
    pagination: {
      marginBottom: "80px",
      '& > .rc-pagination-item': {
        backgroundColor: 'white',
        border: "1px solid #666",
        color: '#666'
      },
      '& > .rc-pagination-item a, & > .rc-pagination-item:hover a': {
        color: '#666'
      },
      '& > .rc-pagination-item-active': {
        backgroundColor: theme.palette.third.main,
        borderColor: theme.palette.third.secondary
      }
    }
  };
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _core.withStyles)(styles, {
  withTheme: true
})(BaseContainer));
exports.default = _default;